export default "__VITE_ASSET__Dqqi1OAo__"